export const isCheckoutEligibleReduceFields = ({
  showRequiredBillingFields,
  isMember,
  isTaxConfigured,
  hasItemWithBillingTaxAddress,
}: {
  showRequiredBillingFields: boolean;
  isMember?: boolean;
  isTaxConfigured: boolean;
  hasItemWithBillingTaxAddress?: boolean;
}): boolean => showRequiredBillingFields && !isMember && (!isTaxConfigured || !hasItemWithBillingTaxAddress);
